import { IonicModule } from '@ionic/angular';
import { StartComponent } from './start/start.component';
import { SlidesComponent } from './slides/slides.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoComponent } from './logo/logo.component';
import { UserItemComponent } from './user-item/user-item.component';
import { UsersListComponent } from './users-list/users-list.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { PatientsListComponent } from './patients-list/patients-list.component';
import { PatientItemComponent } from './patient-item/patient-item.component';
import { PatientDetailsComponent } from './patient-details/patient-details.component';
import { PipesModule } from '../pipes/pipes.module';
import { PatientCodePipe } from '../pipes/patient-code.pipe';
import { ModalBaseComponent } from './modal-base/modal-base.component';


@NgModule({
  declarations: [
    SlidesComponent,
    StartComponent,
    LogoComponent,
    ModalBaseComponent,
    PatientsListComponent,
    PatientItemComponent,
    PatientDetailsComponent,
    UsersListComponent,
    UserItemComponent,
    UserDetailsComponent
  ],
  exports: [
    SlidesComponent,
    StartComponent,
    LogoComponent,
    ModalBaseComponent,
    PatientsListComponent,
    PatientItemComponent,
    PatientDetailsComponent,
    UsersListComponent,
    UserItemComponent,
    UserDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    PipesModule
  ],
  providers: [PatientCodePipe]
})
export class ComponentsModule { }
